import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de triangle";
const DESCRIPTION =
  "Calculatrice de triangle pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de triangle, calculatrice de triangle, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/triangle-calculator/";
function TriangleCalculator() {
  const [sideA, setSideA] = useState("");
  const [sideB, setSideB] = useState("");
  const [sideC, setSideC] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!sideA || !sideB || !sideC) {
        setError("Veuillez entrer les trois côtés");
        setResult(null);
        return;
      }
      const a = parseFloat(sideA);
      const b = parseFloat(sideB);
      const c = parseFloat(sideC);
      if (a <= 0 || b <= 0 || c <= 0) {
        setError("Les côtés doivent être positifs");
        setResult(null);
        return;
      }
      if (a + b <= c || a + c <= b || b + c <= a) {
        setError("Côtés invalides pour un triangle");
        setResult(null);
        return;
      }
      const perimeter = a + b + c;
      const s = perimeter / 2;
      const area = Math.sqrt(s * (s - a) * (s - b) * (s - c));
      setResult({
        area: area.toFixed(2),
        perimeter: perimeter.toFixed(2)
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de triangle calcule l'aire et le périmètre
                  en utilisant la formule d'Héron.
                </p>
                <ul>
                  <li>Formule d'Héron pour l'aire</li>
                  <li>Calculs géométriques</li>
                  <li>Validation du triangle</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Côté A
                      </label>
                      <input
                        type="number"
                        value={sideA}
                        onChange={(e) => setSideA(e.target.value)}
                        placeholder="Côté A"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Côté B
                      </label>
                      <input
                        type="number"
                        value={sideB}
                        onChange={(e) => setSideB(e.target.value)}
                        placeholder="Côté B"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Côté C
                      </label>
                      <input
                        type="number"
                        value={sideC}
                        onChange={(e) => setSideC(e.target.value)}
                        placeholder="Côté C"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Aire: <strong>{result.area}</strong></p>
                      <p>Périmètre: <strong>{result.perimeter}</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'un triangle et ses types</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Un triangle est un polygone à 3 sommets. Types selon les côtés :
                        Équilatéral (3 côtés égaux), Isocèle (2 côtés égaux), Scalène (tous différents).
                        Types selon les angles : Rectangle (un angle de 90°),
                        Obtus (un angle supérieur à 90°), Aigu (tous les angles inférieurs à 90°).
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Faits, théorèmes et lois</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La somme des angles d'un triangle est toujours 180°.
                        Théorème de Pythagore : a² + b² = c² (pour un triangle rectangle).
                        Loi des sinus : a/sin(A) = b/sin(B) = c/sin(C).
                        Loi des cosinus : A = arccos((b² + c² − a²) / 2bc).
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Aire du triangle</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Formule de base : Aire = (1/2) × base × hauteur.
                        Avec deux côtés et un angle : Aire = (1/2) × a × b × sin(C).
                        Formule de Héron : Aire = √(s(s−a)(s−b)(s−c)) où s = (a+b+c)/2.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>La médiane</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La médiane est un segment allant d'un sommet au milieu
                        du côté opposé. Les trois médianes d'un triangle se croisent
                        en un point appelé centroïde (centre de gravité).
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Le rayon inscrit</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le rayon inscrit (inradius) est le rayon du cercle inscrit
                        dans le triangle. Il se calcule par : r = Aire / s,
                        où s = (a + b + c) / 2 est le demi-périmètre.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Le rayon circonscrit</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le rayon circonscrit (circumradius) est le rayon du cercle
                        passant par les trois sommets du triangle.
                        Il se calcule par : R = a / (2 × sin(A)).
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default TriangleCalculator;
